/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import React from "react";
import { projectData } from "../../Data/Data";

const Project = () => {
  return (
    <div className="p-0 m-0 box-border">
      <div className="w-[90%] mx-auto py-12">
        <div className="flex flex-col lg:flex-row flex-wrap gap-6  justify-between items-center">
          {projectData?.map((item) => (
            <div key={item.id} className="w-[350px] h-[300px]">
              <img
                src={item.project_img}
                alt=""
                className="w-full h-full rounded-md"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Project;
